// Calendly popup loader + opener (works without npm package, uses official widget script)
const CALENDLY_CSS = "https://assets.calendly.com/assets/external/widget.css";
const CALENDLY_JS = "https://assets.calendly.com/assets/external/widget.js";

let scriptInjected = false;

export function loadCalendly() {
  if (typeof document === "undefined" || scriptInjected) return;
  if (!document.querySelector(`link[href="${CALENDLY_CSS}"]`)) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = CALENDLY_CSS;
    document.head.appendChild(link);
  }
  if (!document.querySelector(`script[src="${CALENDLY_JS}"]`)) {
    const script = document.createElement("script");
    script.src = CALENDLY_JS;
    script.async = true;
    document.body.appendChild(script);
  }
  scriptInjected = true;
}

export function openCalendly(url) {
  if (typeof window === "undefined") return;
  if (window.Calendly && typeof window.Calendly.initPopupWidget === "function") {
    window.Calendly.initPopupWidget({ url });
    return;
  }
  // Fallback if widget script hasn't finished loading yet
  window.open(url, "_blank", "noopener,noreferrer");
}
